import type { FacilityStorageAreaType } from '../types/db.ts';

export const HAZ_WASTE_ACCUMULATION_AREA_TYPES = ['satellite', 'central-accumulation'] as const;
export type HazWasteAccumulationAreaType = (typeof HAZ_WASTE_ACCUMULATION_AREA_TYPES)[number];

export function hazWasteAccumulationAreaType(location: {
  areaType: FacilityStorageAreaType | null;
  isHazWasteRegulated: boolean;
}): null | HazWasteAccumulationAreaType {
  if (!location.isHazWasteRegulated) {
    return null;
  }
  return HAZ_WASTE_ACCUMULATION_AREA_TYPES.includes(location.areaType as HazWasteAccumulationAreaType)
    ? (location.areaType as HazWasteAccumulationAreaType)
    : null;
}

export function isHazWasteAccumulationArea(location: {
  areaType: FacilityStorageAreaType | null;
  isHazWasteRegulated: boolean;
}): boolean {
  return hazWasteAccumulationAreaType(location) !== null;
}

export function validateStorageLocationRegulatoryState(location: {
  areaType: FacilityStorageAreaType | null;
  isHazWasteRegulated: boolean;
}): void {
  const accumulationType = HAZ_WASTE_ACCUMULATION_AREA_TYPES.includes(
    location.areaType as HazWasteAccumulationAreaType,
  );
  if (location.isHazWasteRegulated !== accumulationType) {
    throw new Error('RCRA-regulated storage locations must be satellite or central accumulation areas.');
  }
}
